// BSD 客服与政策页：手机宽度下目录默认收起，点目录项后自动收起；
// 10-21：日期框统一显示英文（负责人「不要中文」，浏览器会按自己的语言显示原生日期文字）；
// 10-21：物流政策、FAQ 的“按活动日期算最晚下单日”（只在浏览器里算，不提交；算法同首页 bsd-home-planner）。
(() => {
  const today = () => {
    const t = new Date();
    t.setHours(0, 0, 0, 0);
    return t;
  };
  const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  // 手动输入年份时浏览器会先给出 0002、0020 这样的值，年份没输完前按“还没选”处理
  const parse = (value) => {
    const p = (value || '').split('-');
    const year = Number(p[0]);
    const day = p.length === 3 && year >= 1900 ? new Date(year, Number(p[1]) - 1, Number(p[2])) : null;
    return day && !Number.isNaN(day.getTime()) ? day : null;
  };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

  const showDate = (input) => {
    const text = input.parentElement && input.parentElement.querySelector('[data-bsd-date-text]');
    if (!text) return;
    const day = parse(input.value);
    text.textContent = day ? day.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'mm/dd/yyyy';
    text.classList.toggle('is-set', !!day);
  };

  const plan = (input) => {
    const card = input.closest('[data-bsd-planner]');
    if (!card) return;
    const out = card.querySelector('[data-bsd-planner-result]');
    const weeks = Number(card.dataset.weeks || 3);
    out.classList.remove('is-notice');
    const day = parse(input.value);
    if (!day) {
      out.textContent = 'Pick a date to see your order-by date.';
      return;
    }
    const now = today();
    if (day <= now) {
      out.textContent = 'Please choose a date after today.';
      out.classList.add('is-notice');
      return;
    }
    const by = new Date(day);
    by.setDate(by.getDate() - weeks * 7);
    if (by < now) {
      out.innerHTML = `Your date is less than ${weeks} weeks away. Please <a href="/pages/contact">contact us</a> before you order — we’ll tell you honestly whether your dress can arrive in time.`;
      out.classList.add('is-notice');
      return;
    }
    const label = by.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: by.getFullYear() !== now.getFullYear() ? 'numeric' : undefined });
    out.innerHTML = `Order by <strong>${esc(label)}</strong> for your dress to arrive in time for your day.`;
  };

  const init = () => {
    const mobile = window.matchMedia('(max-width: 749px)');
    document.querySelectorAll('.bsd-care__toc').forEach((toc) => {
      if (toc.dataset.ready) return;
      toc.dataset.ready = 'true';
      if (mobile.matches) toc.removeAttribute('open');
      toc.addEventListener('click', (event) => {
        if (mobile.matches && event.target.closest('a')) toc.removeAttribute('open');
      });
    });
    // 日期框最早只能选明天；返回本页时浏览器会恢复已填的日期，按已填日期重新显示
    const tomorrow = today();
    tomorrow.setDate(tomorrow.getDate() + 1);
    document.querySelectorAll('.bsd-care [data-bsd-date]').forEach((input) => {
      input.min = iso(tomorrow);
      showDate(input);
      if (input.matches('[data-bsd-planner-input]') && input.value) plan(input);
    });
  };

  const onChange = (event) => {
    const input = event.target;
    if (!input.matches || !input.matches('.bsd-care [data-bsd-date]')) return;
    showDate(input);
    if (input.matches('[data-bsd-planner-input]')) plan(input);
  };
  document.addEventListener('change', onChange);
  document.addEventListener('input', onChange);
  // 10-23 负责人 iPhone 上原生日期框「点了还是没反应」：日期框改成按钮 + 自制日历（bsd-datepicker.js），
  // 原来点日期框调 showPicker 和触屏补开的那段不再需要，已删除；选好日期后自制日历派发 input / change，上面照常显示和计算

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
